(function () {
  'use strict';

  angular.module('wsLrs.services').factory("VerbResources", ['Api', '$http', function (Api, $http) {
    return {
      save: function save(verbId, display) {
        var aliasEndpoint = Api.url("/acc/verbs/display");
        var displayRule = {
          id: verbId,
          display: display
        };
        return $http.post(aliasEndpoint, displayRule);
      },
      getRecent: function getRecent(limit) {
        var params = {
          _limit: limit,
          order_by: "-updated"
        };
        return $http.get(Api.url("/acc/verbs"), {
          params: params
        });
      }
    };
  }]);
})();
